import { finish, error } from '../../../modules/user/actions/login';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/session', {
        email: action.email,
        password: action.password
    }).then(
        (data) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
